import React from 'react';
import { DropTarget } from 'react-dnd';

function TaskDroppable({connectDropTarget, isOver, option, className, filledClassName}) {
    let classNameOver = isOver || option ? '.task-droppable-over' : '';
    let classNameFilled = option ? (filledClassName !== undefined) ? filledClassName : 'task-droppable-filled' : 'task-droppable-empty';
    
    return (
      <div ref={connectDropTarget} className={`task-droppable ${className} ${classNameOver} ${classNameFilled}`}>
        <div>
          {option && (option.label)}
        </div>
      </div>
    )
  }

  export default DropTarget(
    'drag',
    {
      drop: (props, monitor) => {
        props.onDrop(props.index, monitor.getItem());
      },
      canDrop(props) {
          return true;
      }
    },
    (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  )(TaskDroppable)